import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";
import Button from "@mui/material/Button";

const links = [
  {
    to: "/",
    name: "Home",
  },
  {
    to: "/solutions",
    name: "Solutions",
  },
  {
    to: "/platform",
    name: "Platform",
  },
  {
    to: "/insights",
    name: "Insights",
  },
  {
    to: "/about",
    name: "About",
  },
  {
    to: "/news",
    name: "News",
  },
  {
    to: "/email",
    name: "Request Demo",
  },
  {
    to: "https://3aware.prismhr-hire.com/",
    name: "Careers",
    external: true,
  },
];

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "background.paper",
        py: {xs: 0, md: 1, lg: 2 }
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Box
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
            }}
          >
            <Link to="/">
              <StaticImage
                src="../images/logo-mark@2x.png"
                loading="eager"
                width={160}
                quality={99}
                formats={["auto", "webp", "avif"]}
                alt=""
                style={{ marginBottom: `var(--space-3)` }}
              />
            </Link>
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            {/* Icon to open menu */}
            <IconButton
              size="large"
              aria-label="site navigation"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="primary.light"
            >
              <MenuIcon />
            </IconButton>
            {/* Menu */}
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
                fontSize: { xs: '1rem', md: '1.15rem' },
              }}
            >
              {/* menu links */}
              {links.map(({ to, name, external }, index) => (
                <MenuItem key={index} onClick={handleCloseNavMenu}
                sx={{
                  fontSize: { xs: '1rem', md: '1.15rem' },
                }}
                >
                  {external ? (
                    <a
                      className="navLink"
                      href={to}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {name}
                    </a>
                  ) : (
                    <Link
                      className="navLink"
                      to={to}
                      activeClassName="activeNavLink"
                    >
                      {name}
                    </Link>
                  )}
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* Main Logo */}
          <Box
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
            }}
          >
            <StaticImage
              src="../images/logo-mark@2x.png"
              loading="eager"
              width={100}
              quality={99}
              formats={["auto", "webp", "avif"]}
              alt=""
              style={{ marginBottom: `var(--space-3)` }}
            />
          </Box>

          {/* Horizontal Navigation */}
          <Box 
            sx={{ 
              flexGrow: 1, 
              display: { xs: "none", md: "flex" }, 
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {/* Main Nav Centered */}
            <Box 
              sx={{
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'center',
                gap: { sm: 1, md: 1, lg: 1 },
                fontSize: { xs: '1rem', md: '1.10rem', lg: '1.15rem', xl: '1.2rem' },
              }}
            >
              {links
                .filter(({ name }) => name !== "Request Demo")
                .map(({ to, name, external }, index) => (
                  external ? (
                    <a
                      key={index}
                      className="navLink"
                      href={to}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {name}
                    </a>
                  ) : (
                    <Link
                      key={index}
                      className="navLink"
                      to={to}
                      activeClassName="activeNavLink"
                    >
                      {name}
                    </Link>
                  )
                ))}
            </Box>

            {/* Demo Button Aligned Right */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {links
                .filter(({ name }) => name === "Request Demo")
                .map(({ to, name }, index) => (
                  <Button
                    key={index}
                    component={Link}
                    to={to}
                    sx={{
                      background: "linear-gradient(90deg,rgba(11, 29, 45, 1) 0%, rgba(2, 80, 76, 1) 50%, rgba(0, 134, 106, 1) 100%)",
                      color: "white",
                      textTransform: "none",
                      whiteSpace: "nowrap",
                      ml: 2,
                      py: "5px",
                      px: 2,
                      fontSize: { xs: '1rem', md: '1.10rem', lg: '1.15rem', xl: '1.2rem' },
                      transition: "scale .15s ease-out",
                      "&:hover": {
                        background: "linear-gradient(115deg, rgba(2, 80, 76, 1) 0%, rgba(0, 134, 106, 1) 95%);",
                        scale: '1.03',
                        transition: "scale .15s ease-out",
                      },
                    }}
                  >
                    {name}
                  </Button>
                ))}
            </Box>
          </Box>
          
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
